'use client';

import { Flex, Link } from '@coolblue-development/freddy';
import { ArrowLeft } from '@coolblue-development/icons';
import { AddToCartPageType } from '@features/add-to-cart-page/typings/AddToCartPageSection';
import { useTranslation } from '@i18n/useTranslation';

import ShoppingCartButton from '../Header/ShoppingCartButton';
import StyledButton from '../ShoppingCartButton.styled';
import { useAddToCartSteps } from './AddToCartStepsProvider';

export function AddToCartStepsNavigation({
  productId,
  shoppingCartUrl,
  pageType
}: {
  productId: number;
  shoppingCartUrl?: string;
  pageType: AddToCartPageType;
}) {
  const { t } = useTranslation('webshop.addToCart');
  const { steps, selectedStep, prevStep, nextStep } = useAddToCartSteps();

  if (steps.length === 1) {
    return <ShoppingCartButton productId={productId} href={shoppingCartUrl!} pageType={pageType} />;
  }

  return (
    <Flex
      columnGap={400}
      flex={{
        xs: 1,
        md: 0.6
      }}
      justifyContent='space-between'
      alignItems='center'
    >
      {selectedStep === steps.length - 1 ? (
        <>
          <Link
            component='button'
            onClick={() => prevStep()}
            startIcon={<ArrowLeft />}
            flex={1}
            sx={{
              justifyContent: 'flex-end'
            }}
          >
            {t('multiStep.back')}
          </Link>

          <StyledButton
            component='a'
            href={shoppingCartUrl}
            flex={{
              xs: 3,
              md: 1
            }}
            variant='action'
            fullWidth
          >
            {t('viewShoppingCart')}
          </StyledButton>
        </>
      ) : (
        <>
          <Link href={shoppingCartUrl} sx={{ textAlign: 'end' }} flex={1} hideUntil='md'>
            {t('viewShoppingCart')}
          </Link>

          <StyledButton
            component='button'
            onClick={() => nextStep()}
            flex={1}
            variant='action'
            fullWidth
          >
            {t('multiStep.forward')}
          </StyledButton>
        </>
      )}
    </Flex>
  );
}
